/* Unik — cart: quick-add, drawer, quantity, toast.
   Talks to Shopify's Cart AJAX API and re-renders the drawer
   through the Section Rendering API. Fully event-delegated, so
   replacing the drawer markup never needs a re-bind. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastTimer;

  function $(sel, scope) { return (scope || document).querySelector(sel); }

  function strings() {
    var el = $('[data-unik-strings]');
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  var T = {};
  document.addEventListener('DOMContentLoaded', function () { T = strings(); });

  function toast(msg) {
    var el = $('[data-toast]');
    if (!el || !msg) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function openDrawer() {
    var d = $('[data-drawer]');
    if (!d) return;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-close-cart]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = $('[data-drawer]');
    if (!d) return;
    d.hidden = true;
    document.body.style.overflow = '';
  }

  function refresh(reopen) {
    return fetch(root + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var host = $('[data-drawer-host]');
        if (!host) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-drawer-host]');
        if (fresh) host.innerHTML = fresh.innerHTML;
        if (reopen) openDrawer();
      });
  }

  function cartRequest(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw new Error(json.description || json.message || 'Cart error');
        return json;
      });
    });
  }

  function addVariant(id, qty, label, btn) {
    if (btn) { btn.disabled = true; btn.dataset.wasLabel = btn.textContent; btn.textContent = T.adding || 'Adding…'; }
    cartRequest('cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCount(cart.item_count);
        return refresh(true);
      })
      .then(function () { toast(label); })
      .catch(function (err) { toast(err.message); })
      .finally(function () {
        if (btn) { btn.disabled = false; if (btn.dataset.wasLabel) btn.textContent = btn.dataset.wasLabel; }
      });
  }

  function changeLine(line, quantity) {
    cartRequest('cart/change.js', { line: Number(line), quantity: Number(quantity) })
      .then(function (cart) {
        setCount(cart.item_count);
        var onCartPage = document.body.hasAttribute('data-cart-page');
        if (onCartPage) { window.location.reload(); return; }
        return refresh(false);
      })
      .catch(function (err) { toast(err.message); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var open = t.closest('[data-open-cart]');
    if (open) { e.preventDefault(); openDrawer(); return; }

    if (t.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); return; }

    var quick = t.closest('[data-quickadd]');
    if (quick) {
      e.preventDefault();
      var card = quick.closest('[data-product-card]');
      var sizes = card && card.querySelector('[data-sizes]');
      if (sizes) { sizes.hidden = false; quick.hidden = true; }
      return;
    }

    var size = t.closest('[data-size]');
    if (size) {
      e.preventDefault();
      var holder = size.closest('[data-product-card], [data-pdp]');
      if (!holder) return;
      holder.querySelectorAll('[data-size]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      size.setAttribute('aria-pressed', 'true');
      holder.dataset.selected = size.dataset.variantId;
      var hidden = holder.querySelector('input[name="id"]');
      if (hidden) hidden.value = size.dataset.variantId;
      var addBtn = holder.querySelector('[data-add]');
      if (addBtn) {
        addBtn.textContent = (T.add_size || 'Add {size} to bag').replace('{size}', size.dataset.size);
        addBtn.disabled = false;
      }
      return;
    }

    var add = t.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var wrap = add.closest('[data-product-card], [data-pdp]');
      var vid = wrap && wrap.dataset.selected;
      if (!vid) { toast(T.pick_size || 'Pick a size first'); return; }
      var picked = wrap.querySelector('[data-size][aria-pressed="true"]');
      var name = (wrap.dataset.colourway || '') + (picked ? ' / ' + picked.dataset.size : '');
      addVariant(vid, 1, (T.reserved || 'Reserved —') + ' ' + name, add);
      return;
    }

    var qty = t.closest('[data-qty]');
    if (qty) {
      e.preventDefault();
      changeLine(qty.dataset.line, qty.dataset.to);
      return;
    }

    var remove = t.closest('[data-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.dataset.line, 0); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
